import { render, staticRenderFns } from "./scrapcost.vue?vue&type=template&id=2983be04&scoped=true&"
import script from "./scrapcost.vue?vue&type=script&lang=js&"
export * from "./scrapcost.vue?vue&type=script&lang=js&"
import style0 from "./scrapcost.vue?vue&type=style&index=0&id=2983be04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983be04",
  null
  
)

export default component.exports